function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FE2F00",
  d: "M40.7458333,40.6875 C40.7458333,42.2753187 39.4530555,43.5625 37.8583333,43.5625 L3.20833333,43.5625 C1.61361112,43.5625 0.320833333,42.2753187 0.320833333,40.6875 L0.320833333,3.3125 C0.320833333,1.72468134 1.61361112,0.4375 3.20833333,0.4375 L32.0833333,0.4375 C32.8363889,0.437575193 33.5596205,0.730567461 34.0988083,1.254 L39.8738083,6.77975 C40.4313103,7.32080991 40.7457572,8.06309253 40.7458333,8.83825 L40.7458333,40.6875 Z"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M17.1414833,30.4525 C16.6307033,30.7061084 16.0244873,30.6784744 15.5391179,30.3794571 C15.0537486,30.0804397 14.7583577,29.5526286 14.7583333,28.9843333 L14.7583333,17.8906667 C14.7583577,17.3223714 15.0537486,16.7945603 15.5391179,16.4955429 C16.0244873,16.1965256 16.6307033,16.1688916 17.1414833,16.4225 L28.2853083,21.97125 C28.8434651,22.2486391 29.1961458,22.8163782 29.1961458,23.4375 C29.1961458,24.0586218 28.8434651,24.6263609 28.2853083,24.90375 L17.1414833,30.4525 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 41 44",
    className: "icon",
    style: {
      "height": "1em",
      "width": "0.93182em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/snap-video.491e9591.svg";
export { SvgComponent as ReactComponent };